module.exports = __webpack_public_path__ + "fonts/6c3554598cc7d64f9941b4060e86cb28.svg";